import { useMutation } from "@tanstack/react-query";
import {
  changePassword,
  getAllSecurityQuestions,
  getSecurityQuestionByUserId,
  loginUser,
  resetPassword,
} from "../../services/authApi";

export const useLoginMutation = () =>
  useMutation({
    mutationFn: (payload) => loginUser(payload),
  });

export const useSecurityQuestionMutation = () =>
  useMutation({
    mutationFn: (userId) => getSecurityQuestionByUserId(userId),
  });

export const useAllSecurityQuestionsMutation = () =>
  useMutation({
    mutationFn: () => getAllSecurityQuestions(),
  });

export const useResetPasswordMutation = () =>
  useMutation({
    mutationFn: (payload) => resetPassword(payload),
  });

export const useChangePasswordMutation = () =>
  useMutation({
    mutationFn: (payload) => changePassword(payload),
  });
